import { ConfigurationValues } from '@cutr/constants/windows/windows';
import { CONFIGURATIONS_OPTIONS } from '@cutr/constants/windows/windows-configurations.ts';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';

import { Label } from '@/windows/primitives/Label';

import { GridSelectModal } from '../../GridSelectModal';
import { unboxLabel } from '../Configurations';
import { useResolvedSystem } from '../ConfigurationsContext';
import { optionFilterBySystemClass } from '../inputs/ConfigurationSelect';
import { ConfigurationComponent } from '.';

const WeatherRailInput = () => {
  const { t } = useTranslation();
  const system = useResolvedSystem();
  const labelId = useId();
  const inputId = useId();

  const weatherRailOptions = CONFIGURATIONS_OPTIONS.weatherRail.options
    .filter((option) => optionFilterBySystemClass(option, { system }))
    .map((config) => ({
      config,
      imagePath: `/sorpetaler/weatherRail/${config.value}.png`,
    }));

  return (
    <>
      <Label id={labelId} htmlFor={inputId}>
        {t(`windows.configurations.weatherRail.label`)}
      </Label>
      <GridSelectModal
        configurationKey="weatherRail"
        dispatchAction="SET_WEATHER_RAIL"
        options={weatherRailOptions}
        buttonId={inputId}
      />
    </>
  );
};

const config: ConfigurationComponent<'weatherRail'> = {
  key: 'weatherRail',
  input: <WeatherRailInput />,
  display: (value: ConfigurationValues['weatherRail']) => (
    <span>{unboxLabel(value?.label)}</span>
  ),
};

export default config;
